import { useEffect, useRef, useState } from "react";

export function useReveal() {
  const ref = useRef(null);
  const [seen, setSeen] = useState(false);
  useEffect(() => {
    const el = ref.current;
    if (!el) return;
    const io = new IntersectionObserver(
      ([e]) => {
        if (e.isIntersecting) {
          setSeen(true);
          io.disconnect();
        }
      },
      { threshold: 0.12 }
    );
    io.observe(el);
    return () => io.disconnect();
  }, []);
  return { ref, cls: seen ? "reveal in" : "reveal" };
}

export function Reveal({ children, delay = 0, className = "", as: Tag = "div", ...rest }) {
  const { ref, cls } = useReveal();
  return (
    <Tag ref={ref} className={`${cls} ${className}`} style={{ transitionDelay: `${delay}ms` }} {...rest}>
      {children}
    </Tag>
  );
}
